import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo_s",
  "use": "logo_s-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\" id=\"logo_s\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.393 12.804H5.64L0 .882h8.007c3.113.007 5.636 2.77 5.637 6.177-.005 3.176-2.353 5.745-5.251 5.745z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol